// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { CHANGE_PASSWORD_REDUCER_KEY } from '../../../../../constants/reducer.constants';

const getState = (state) => state[CHANGE_PASSWORD_REDUCER_KEY];

export const getError = createSelector(getState, (state) => state && state?.get('error'));

export const getSuccess = createSelector(getState, (state) => state && state?.get('success'));

export const getChangeErrorResponse = (state) => {
  return state?.[CHANGE_PASSWORD_REDUCER_KEY] && state?.[CHANGE_PASSWORD_REDUCER_KEY]?.get('error');
};
